import React from 'react';
import { scoped } from '../../../helpers/utils';
import s from './emailStatusMessage.scss';

export function EmailStatusMessage({ status }) {
  const messageMap = {
    success: '✔️ Success! Your message has been sent.',
    error: '❌ Sorry, something went wrong. Please try again.',
  };
  return (
    <>
      {status !== 'idle' && (
        <div
          className={scoped(
            s,
            'formStatus',
            `formStatus--${status}`,
            'box-shadow-1dp'
          )}
        >
          <p>{messageMap[status]}</p>
        </div>
      )}
    </>
  );
}
